import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import VisitSummaryContent from "components/visitSummaryAccordion/VisitSummaryContent";
import { behaviorHealthVisitFlowReducers } from "reducers/behavior_health/behaviorHealthVisitFlowReducer";
import { bh_sub_steps } from "helpers/enum";
import moment from "moment";
import { ContentText } from "pages/home/myVisits/MiscComponents";
import { capitalize } from "helpers/lodashPolyfills";

function VisitDetailsForBHSummary({ readOnly, data }) {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <VisitSummaryContent
      readOnly={readOnly}
      onEditClick={() => {
        dispatch(
          behaviorHealthVisitFlowReducers.currentScreen({
            value: bh_sub_steps.select_condition,
          })
        );
        history.push("/visit/behavior-health/new-visit");
      }}
    >
      <div className="flex flex-col py-4 mb-4 space-y-4 rounded-md bg-backgroundWhite">
        <ContentText label={"Patient Name"} child={data.patient_name} />
        <ContentText label={"State of Residence"} child={data.state} />
        {data?.meta?.booking_info?.selectedDate && (
          <ContentText
            label={"Appointment Date"}
            child={moment(data?.meta?.booking_info?.selectedDate).format(
              "dddd MM-DD-YYYY"
            )}
          />
        )}
        {data.meta.booking_info.slotInfo && (
          <ContentText
            label={"Slot time"}
            child={
              <p>
                {moment(
                  data.meta.booking_info.slotInfo.start_time,
                  "hh:mma"
                ).format("LT")}
                {data.meta.booking_info.slotInfo.end_time &&
                  " - " +
                    moment(
                      data.meta.booking_info.slotInfo.end_time,
                      "hh:mma"
                    ).format("LT")}
              </p>
            }
          />
        )}
        {data?.therapy_for?.length > 0 && (
          <ContentText
            label={"Therapy For"}
            child={capitalize(data.therapy_for)}
          />
        )}
        {data?.therapy_reasons?.length > 0 && (
          <ContentText
            label={"Therapy Reasons"}
            comma={false}
            child={data.therapy_reasons}
          />
        )}
      </div>
    </VisitSummaryContent>
  );
}

export default VisitDetailsForBHSummary;
